module.exports = __webpack_public_path__ + "static/hero-07-75248a0e9a85d09a9b1c410693408404.jpg";